import React, { useEffect } from 'react';
import { useParams, Switch, Route } from 'react-router-dom';
import { useCollect } from 'hooks';

import Show from 'components/Show';
import Icon from 'components/Misc/Icon';
import Container from 'components/Misc/Container';

import Information from 'containers/Parent/Exams/Profile/Widgets/Information';
import Description from 'containers/Parent/Exams/Profile/Widgets/Description';

import Tasks from 'containers/Parent/Exams/Profile/Tasks';
import Review from 'containers/Parent/Exams/Profile/Review';

import { useExamStudentStore } from 'store/exam/useExamStudentStore';

const Profile = () => {
	// Store current take id
	const { id } = useParams();

	// Use exam's store
	const [take, onInit, onReset] = useExamStudentStore(state => [
		state.take,
		state.onInit,
		state.onReset
	]);

	// Store collected take
	const [[result, progress], collect] = useCollect(`takes/${id}`);

	// Collect exam on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	// Initialize exam's data after collection
	useEffect(() => {
		if (result) onInit(result);

		// Reset exam's data on unmount
		return () => onReset();
	}, [result]);

	return (
		<div className="mx-auto max-w-screen-md space-y-4">
			<Container className="p-4 space-y-2">
				{/* Exam's information */}
				<Information />

				{/* Exam's description */}
				<Description />

				{/* Exam's controls */}
				<div className="flex flex-col space-y-4 items-end md:flex-row md:justify-end md:items-center md:space-x-4 md:space-y-0">
					{/* Show finshed information */}
					<Show if={take.state === 'finished'}>
						<div className="py-3 px-4 flex-1 flex space-x-2 items-center bg-emerald-500 text-white rounded-lg">
							<Icon
								icon="check"
								className="text-xl"
							/>

							<div className="flex-1">
								Pārbaudes darbs ir nodots pedagogam vērtēšanā!
							</div>
						</div>
					</Show>

					{/* Show reviewed information */}
					<Show if={take.state === 'reviewed'}>
						<div className="flex-1 flex items-center space-x-4">
							<div className="flex-1 text-neutral-700 dark:text-white">
								Pārbaudes darbs ir izvērtēts!
							</div>

							<div className="w-10 h-10 leading-10 text-center text-neutral-800 bg-neutral-50 dark:bg-neutral-700 dark:text-white text-2xl rounded-lg">
								{take.mark}
							</div>
						</div>
					</Show>
				</div>
			</Container>

			{/* Task's view */}
			<Switch>
				<Route exact path="/exams/task/:id(\d+)/:taskId(\d+)">
					<Show if={take.state === 'reviewed'}>
						<Review />
					</Show>
 				</Route>
			</Switch>

			{/* Display exam's tasks */}
			<Tasks progress={progress} />
		</div>
	);
};

export default Profile;